import PrintWebSocketService from '@/services/PrintWebSocketService';

export function usePrinter() {
  const loadPrinters = async store => {
    try {
      const printers = await PrintWebSocketService.getPrinters();
      const availablePrinters = JSON.parse(printers).printers;

      store.commit('WEBSOCKET_SET_PRINTERS', availablePrinters);

      const savedPrinter = localStorage.getItem('defaultPrinter');
      if (savedPrinter && availablePrinters.includes(savedPrinter)) {
        store.commit('WEBSOCKET_SET_DEFAULT_PRINTER', savedPrinter);
      }

      return availablePrinters;
    } catch (error) {
      console.error('Erro ao carregar impressoras:', error);
      throw error;
    }
  };

  const getAvailablePrinters = async () => {
    try {
      const printers = await PrintWebSocketService.getPrinters();
      return JSON.parse(printers).printers;
    } catch (error) {
      console.error('Erro ao carregar impressoras:', error);
      throw error;
    }
  };

  const getDefaultPrinter = () => {
    return localStorage.getItem('defaultPrinter');
  };

  const setDefaultPrinter = (printer, store) => {
    localStorage.setItem('defaultPrinter', printer);
    store.commit('WEBSOCKET_SET_DEFAULT_PRINTER', printer);
  };

  const saveDefaultPrinter = printer => {
    localStorage.setItem('defaultPrinter', printer);
  };

  const formatPrinters = availablePrinters => {
    if (!availablePrinters || !Array.isArray(availablePrinters)) {
      return [];
    }

    if (availablePrinters.length > 0 && typeof availablePrinters[0] === 'object') {
      return availablePrinters;
    }

    return availablePrinters.map(printer => ({
      value: printer,
      label: printer,
    }));
  };

  const getStatusText = (connectionState, texts = {}) => {
    const defaultTexts = {
      connected: 'Conectado',
      connecting: 'Conectando...',
      disconnected: 'Desconectado',
    };

    const statusTexts = { ...defaultTexts, ...texts };

    switch (connectionState) {
      case 'connected':
        return statusTexts.connected;
      case 'connecting':
        return statusTexts.connecting;
      case 'disconnected':
      default:
        return statusTexts.disconnected;
    }
  };

  return {
    loadPrinters,
    getAvailablePrinters,
    getDefaultPrinter,
    setDefaultPrinter,
    saveDefaultPrinter,
    formatPrinters,
    getStatusText,
  };
}
